import { createAction, props } from "@ngrx/store";
import { FullTableState } from "./app.reducer";
import { TableLazyLoadEvent } from 'primeng/table';


export const saveFullTableState = createAction(
  '[Table] Save Full Table State',
  props<{ tableState: FullTableState }>()
);

export const saveTableLazyLoadEvent = createAction(
  '[Table] Save Lazy Load Event',
  props<{ lazyLoadEvent: FullTableState; componentName: string }>()
);

export const clearTableLazyLoadEvent = createAction(
  '[Table] Clear Lazy Load Event',
  props<{ componentName: string }>()
);

export const loadNotFound = createAction('[App] Not Found');

export const showMessage = createAction(
  '[Global] Show Message',
  props<{
    key: string;
    severity: 'success' | 'info' | 'warn' | 'error';
    summary: string;
    detail: string;
  }>()
);
